import React, { useCallback } from 'react';
import EventLabel from '../../components/EventLabel/EventLabel';
import { toStringTwoDecimals } from '../../utils/money.utils';

export default function OrderTotalSummary({ flatOrderRows, environment, orders, breakouts, mainEvent }) {
  const isVatExempt = orderRow => {
    const targetBreakout = orderRow?.eventId === mainEvent?.eventId ? mainEvent : breakouts?.find(b => b.eventId === orderRow?.eventId);
    const order = orders?.find(a => a.leader) || orders?.[0];

    if (!order?.orderExtra || !targetBreakout?.allowReverseCharge) return false;
    if (order?.orderExtra?.some(a => a.name === 'vatExempt') && order?.orderExtra.some(a => a.name === 'sweVat')) return true;
    return order?.orderExtra.find(a => a.name === 'vatExempt')?.value;
  };

  const getVatExempt = () => {
    let removeVat = false;

    const leader = orders?.find(a => a.leader) ?? orders?.[0];
    const orderExtra = leader?.['orderExtra'];

    if (orderExtra) {
      const vatExempt = orderExtra?.find(a => a.name === 'vatExempt');
      removeVat = vatExempt ? vatExempt.value : false;
    }

    return removeVat;
  };

  const calcTotalExVat = useCallback(() => {
    const totalExVat = flatOrderRows.reduce((acc, or) => {
      return (acc += ( or.amount - or.discountAmount) * or.quantity);
    }, 0);

    
    return totalExVat;
  }, [flatOrderRows]);

  const calcTotalVat = useCallback(() => {
    const totalVat = flatOrderRows.reduce((acc, or) => {
      return (acc += or.vatAmount * or.quantity );
    }, 0);

    return totalVat;
  }, [flatOrderRows]);

  const calcTotalSum = useCallback(() => {
    var rowTotal = 0;
    flatOrderRows.map(or => {
      rowTotal += isVatExempt(or) ? or.amount - or.discountAmount : or.rowTotal;
    });
    return rowTotal;
  }, [flatOrderRows]);

  return (
    <div className="cms-order-total-container">
      <div className="cms-table ">
        <div className="cms-table-container">
          <table className="cms-table small">
            <thead>
              <tr>
                <th>
                  <EventLabel name="SummaryHeader" groupName="CMS.OrderSummary" />
                </th>
                <th>
                  <EventLabel name="SummaryAmount" groupName="CMS.OrderSummary" />
                </th>
              </tr>
            </thead>
            <tbody>
              {toStringTwoDecimals(calcTotalVat(), 2) > 0 ? (
                <>
                  <tr>
                    <td className="text-right">
                      <EventLabel name="TotalExVat" groupName="CMS.OrderSummary" />
                    </td>
                    <td align="right" className="text-right">
                      {toStringTwoDecimals(calcTotalExVat(), 2)}
                      {` ${environment.currency}`}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-right">
                      <EventLabel name="TotalVat" groupName="CMS.OrderSummary" />
                    </td>
                    <td align="right" className="text-right">
                      {toStringTwoDecimals(calcTotalVat(), 2)}
                      {` ${environment.currency}`}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-right">
                      <EventLabel name="TotalIncVat" groupName="CMS.OrderSummary" />
                    </td>
                    <td align="right" style={{ textAlign: 'right' }}>
                      {toStringTwoDecimals(calcTotalSum(), 2)}
                      {` ${environment.currency}`}
                    </td>
                  </tr>
                </>
              ) : (
                <tr>
                  <td align="right" className="text-right">
                    <EventLabel name="TotalNoVat" groupName="CMS.OrderSummary" />
                  </td>
                  <td align="right" className="text-right">
                    {toStringTwoDecimals(calcTotalSum(), 2)}
                    {` ${environment.currency}`}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
